export var MatchmakingCardCategory = /*#__PURE__*/ function(MatchmakingCardCategory) {
    MatchmakingCardCategory[MatchmakingCardCategory["Bots"] = 0] = "Bots";
    MatchmakingCardCategory[MatchmakingCardCategory["Casual"] = 1] = "Casual";
    MatchmakingCardCategory[MatchmakingCardCategory["Ranked"] = 2] = "Ranked";
    return MatchmakingCardCategory;
}({});
